import { HttpContextToken } from '@angular/common/http'

export const SUPPRESS_HTTP_ERROR_NOTIFICATION = new HttpContextToken<boolean>(
  () => false
)
